import { jsx as _jsx } from "react/jsx-runtime";
import { isEmpty } from 'lodash';
import { forwardRef, useCallback, useEffect, useImperativeHandle } from 'react';
import { FiltersContent } from './FiltersContent';
const updateFilters = (filters, values) => {
    for (const key of Object.keys(values)) {
        if (isEmpty(values[key]) ||
            (key === 'location' && values[key].location === '')) {
            delete filters[key];
        }
        else {
            filters[key] = values[key];
        }
    }
    return filters;
};
export const BlockFilters = forwardRef(({ actionButtonsCanOverflow, blockData, blockQuery, clearFilters, data, dataTestId, filterRows, filters, filtersByRow, forceEnableClearFilters = (dataFilter) => Boolean(dataFilter === null || dataFilter === void 0 ? void 0 : dataFilter['block-tags']), header, modal, setBlockData, setBlockQuery, }, ref) => {
    const handleChangeFilters = useCallback((values) => {
        if (values) {
            setBlockQuery((prevQuery) => updateFilters(prevQuery, values));
        }
        else {
            setBlockQuery(null);
        }
    }, [setBlockQuery]);
    useImperativeHandle(ref, () => ({
        clearFilters,
    }));
    useEffect(() => {
        setBlockData(blockQuery);
    }, [blockQuery, setBlockData]);
    useEffect(() => {
        if (blockData === null) {
            handleChangeFilters(null);
        }
    }, [blockData, handleChangeFilters]);
    if (!(filters === null || filters === void 0 ? void 0 : filters.length)) {
        return null;
    }
    return (_jsx(FiltersContent, { actionButtonsCanOverflow: actionButtonsCanOverflow, clearFilters: clearFilters, dataTestId: dataTestId, filterRows: filterRows, filters: filters, filtersByRow: filtersByRow, forceEnableClearFilters: forceEnableClearFilters === null || forceEnableClearFilters === void 0 ? void 0 : forceEnableClearFilters(data), header: header, modal: modal, onChangeFilters: handleChangeFilters, values: blockQuery }));
});
//# sourceMappingURL=index.js.map